import { TRUST_POINTS } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

export default function Trust() {
    return (
        <section id="trust" className="scroll-mt-20 bg-navy-deep py-24 lg:py-32" data-testid="trust-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 09 &mdash; Why Viet Medica</ChapterTag>
                <SectionHead className="mt-8" eyebrow="Trust" title="Why Work with Viet Medica?" />

                <div className="mt-14 grid grid-cols-1 gap-px bg-white/8 sm:grid-cols-2 lg:grid-cols-4">
                    {TRUST_POINTS.map((t, i) => (
                        <FadeUp key={t.label} delay={(i % 4) * 0.07} className="h-full">
                            <div
                                className="group flex h-full min-h-[150px] flex-col justify-between bg-navy-deep p-7 transition-colors duration-500 hover:bg-navy-surface"
                                data-testid={`trust-point-${i + 1}`}
                            >
                                <t.icon size={22} className="text-gold transition-transform duration-500 group-hover:-translate-y-1" aria-hidden="true" />
                                <p className="mt-8 text-sm font-medium leading-snug text-slate-200">{t.label}</p>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
